import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 导入语言包
import zhLocale from './locales/zh'

Vue.use(VueI18n)

// 注册i18n实例并导出
const i18n = new VueI18n({
  locale: 'zh', // 设置默认语言
  fallbackLocale: 'zh', // 设置回退语言
  messages: {
    zh: zhLocale,
  }
})
export function getImagePath(path) {
  return './images/' + i18n.locale + '/' + path
}
export default i18n
